// extracted by css-extract-rspack-plugin
export default {"wrapper":"_52f7ccf3"};